<template>
  <div>
    <span
      class="item-counter"
      v-if="statsViewType === 1"
      v-for="(stat, idx) in stats"
      :key="idx"
      >{{ Math.round(stat) }} <span v-if="stat.length > 1">|</span>
      <span style="font-size: 10px"
        >({{ calcPercent(Math.round(stat)) }})</span
      ></span
    >
    <span
      class="item-counter"
      v-if="statsViewType === 2"
      v-for="(stat, idx) in stats"
      :key="idx"
      >{{ Math.round(stat) }} <span v-if="stat.length">|</span></span
    >
    <span
      class="item-counter"
      v-if="statsViewType === 3"
      v-for="(stat, idx) in stats"
      :key="idx"
      >({{ calcPercent(Math.round(stat)) }})<span v-if="stat.length > 1"
        >|</span
      ></span
    >
  </div>
</template>

<script>
export default {
  name: "MultiSelectStatsNumbers.component",

  props: {
    expansionData: {
      type: Array,
      default: () => []
    },
    selectedTab: {
      type: String
    },
    statsViewType: {
      type: Number,
      default: 1
    },
    total: {
      type: Number
    },
    stats: {
      type: Array,
      default: () => []
    },
    sector: {
      type: String
    }
  },

  methods: {
    calcPercent(number) {
      let percent = (number / this.total) * 100;
      return percent.toFixed(1) + "%";
    },
    getData() {
      if (this.expansionData.length > 0) {
        ///return this.expansionData.expansion.active.count;
      } else {
        return this.stats;
      }
    }
  },
  watch: {
    expansionData() {
      if (this.expansionData.length > 0) {
        this.getData();
      } else {
        this.getData();
      }
    }
  }
};
</script>

<style scoped>
.item-counter {
  font-size: 12px;
  text-align: center;
  /*min-width: 60px;*/
  /*padding-left: 121px;*/
}
</style>
